export default () => {
  const url =
    window.location.hostname == 'app.aleri.ca'
      ? 'https://aleri-prod.herokuapp.com'
      : 'https://aleri.herokuapp.com';
  return process.env.NODE_ENV == 'production' ? url : 'http://localhost:5000';
};
